<template>

    <v-navigation-drawer width="230" v-model="sideNav" :temporary="$vuetify.breakpoint.smAndDown" :permanent="$vuetify.breakpoint.mdAndUp" :fixed="$vuetify.breakpoint.smAndDown">

        <v-toolbar flat class="transparent">
            <v-list class="pa-0">
              <v-list-tile
                    to="/"
                    :ripple="$vuetify.breakpoint.mdAndUp"
              >
                <v-list-tile-action>
                    <v-icon class="ml-2 icon-calculator"></v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Berechnen</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-toolbar>

        <v-divider></v-divider>

        <v-list :dense="$vuetify.breakpoint.mdAndUp" class="pt-0">

            <template v-for="(itemBox, index1) in sideNavItems">

                <v-list-tile
                    v-if="item.title"
                    v-for="item in itemBox"
                    :key="item.title"
                    :to="item.path"
                    avatar
                    :ripple="$vuetify.breakpoint.mdAndUp"
                >

                    <v-list-tile-avatar v-if="typeof item.picture !== 'undefined'">
                        <v-img :src="item.picture" contain></v-img>
                    </v-list-tile-avatar>

                    <v-list-tile-action v-if="typeof item.picture === 'undefined'">
                        <v-icon class="ml-2" :class="item.icon"></v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>

                </v-list-tile>

                <template v-for="(item, index) in itemBox">
                    <v-divider :key="index1+'-'+index" v-if="item.isDivider"></v-divider>
                </template>

            </template>

        </v-list>

      </v-navigation-drawer>

</template>

<script>
    export default {
        name: 'sideNavBar',
        data: () => ({

        }),
        computed: {

            sideNavItems() {
                return this.$store.getters.sideNavItems;
            },

            sideNav: {
                set: function(val){
                    this.$store.dispatch("sideNav", val);
                },
                get() {
                    return this.$store.getters.sideNav
                }
            }
        }
    }
</script>

<style scoped>


</style>

